/*
 * @Author: mayanxia
 * @Date: 2023-03-21 15:04:59
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-07-26 11:15:07
 */

<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备编号')">
              <a-input :placeholder="$t('输入设备编号查询')" v-model="queryParam.deviceId"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="12" :lg="12" :md="12" :sm="24">
            <a-form-item :label="$t('污染物因子')">
              <a-radio-group v-model="queryParam.cmd">
                <a-radio-button v-for="item of pollutantFators" :value="item.key" :key="item.key">
                  {{item.title}}
                </a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
            <a-col :span="8">
              <a-form-model-item :label="$t('上报时间')">
                <!-- <a-range-picker
                  v-model="date"
                  :placeholder="['查询起始时间', '查询结束时间']"
                  format="YYYY-MM-DD"
                  @change="onDateRangeChange"
                /> -->
                <a-date-picker v-model="queryParam.beginDate" format="YYYY-MM-DD" valueFormat="YYYY-MM-DD" />
              </a-form-model-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <!-- <a-button type="primary" icon="download" @click="handleExportXls('实时数据')">导出</a-button> -->
    </div>

    <!-- table区域-begin -->
    <div style="height: 600px;">
      <a-spin :spinning="loading" style="width: 100%"  />
        <Echart ref="option" :options="option" style="height: 100%"></Echart>
    </div>
  </a-card>
</template>

<script>

  import JInput from '@/components/jeecg/JInput'
  import { getAction } from '@/api/manage'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import echarts from 'echarts/lib/echarts';
  import {isUndefinedAndNull} from '@/utils/validate'
  const colorList = ["#9E87FF", '#73DDFF', '#fe9a8b', '#F56948', '#9E87FF']

  export default {
    name: 'PartWaterQualityMinuteRecordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JInput
    },
    data () {
      return {
        description: '水质监测分钟数据管理页面',
        url: {
          list: "/jeecg-charge/part/partWaterQualityMinuteRecord/analysisList",
          exportXlsUrl: "/jeecg-charge/part/partWaterQualityMinuteRecord/exportXls",
        },
        columns: [],
        dictOptions:{},
        /* 排序参数 */
        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        dateType: 2,
        queryParam:{
          cmd: 'w01001'
        },
        option: {},
        disableMixinCreated: true,
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：污染物因子选项使用 computed 以响应语言切换
      pollutantFators() {
        return [
          {key: 'w01001',title: this.$t('PH值')},
          {key: 'w01002',title: this.$t('色度')},
          {key: 'w01003',title: this.$t('浑浊度')},
          {key: 'w01006',title: this.$t('溶解性总固体')},
          {key: 'w10000',title: this.$t('硬度')},
          {key: 'w10001',title: this.$t('ORP')},
          {key: 'w21022',title: this.$t('氯化物')},
          {key: 'w21024',title: this.$t('余氯')},
          {key: 'w21038',title: this.$t('硫酸盐')},
          {key: 'w01010',title: this.$t('温度值')},
          {key: 'w01014',title: this.$t('电导率')}
        ]
      },
    },
    methods: {
      initDictConfig(){
      },
      loadData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t("请设置url.list属性!"))
          return
        }
        this.option = this.$options.data.call(this).option;
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        if(isUndefinedAndNull(params['deviceId'])) {
          return this.$message.error(this.$t("请输入表编号，进行查询"));
        }
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            let dataSource = res.result;
            this.dataSource = dataSource;
            this.setOption();
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      setOption() {
        let xData = this.dataSource.dateArr

        let seriesData = this.dealSeriesData()
        if(seriesData==[]) {
          return;
        }
        this.option = {
          backgroundColor: '#fff',
          title: {
            text: this.$t('污染因子分析'),
            textStyle: {
                fontSize: 12,
                fontWeight: 400
            },
            left: 'center',
            top: '5%'
          },
          legend: {
            icon: 'circle',
            top: '5%',
            right: '5%',
            itemWidth: 6,
            itemGap: 20,
            textStyle: {
              color: '#556677'
            }
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
                label: {
                  show: true,
                  backgroundColor: '#fff',
                  color: '#556677',
                  borderColor: 'rgba(0,0,0,0)',
                  shadowColor: 'rgba(0,0,0,0)',
                  shadowOffsetY: 0
                },
                lineStyle: {
                  width: 0
                }
            },
            backgroundColor: '#fff',
            textStyle: {
              color: '#5c6c7c'
            },
            padding: [10, 10],
            extraCssText: 'box-shadow: 1px 0 2px 0 rgba(163,163,163,0.5)'
          },
          grid: {
            top: '15%'
          },
          xAxis: [{
            type: 'category',
            data: xData,
            axisLine: {
              lineStyle: {
                color: 'rgba(107,107,107,0.37)', //x轴颜色
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              textStyle: {
                color: '#999' //坐标轴字颜色
              },
              margin: 15
            },
            axisPointer: {
              label: {
                padding: [11, 5, 7],
                backgroundColor: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [{
                    offset: 0,
                    color: '#fff' // 0% 处的颜色
                  }, {
                    offset: 0.9,
                    color: '#fff' // 0% 处的颜色
                  }, {
                    offset: 0.9,
                    color: '#33c0cd' // 0% 处的颜色
                  }, {
                    offset: 1,
                    color: '#33c0cd' // 100% 处的颜色
                  }],
                  global: false // 缺省为 false
                }
              }
            },
            boundaryGap: false
          }],
          yAxis: [{
            type: 'value',
            scale: true,
            axisTick: {
              show: false
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: 'rgba(107,107,107,0.37)', //y轴颜色
              }
            },
            axisLabel: {
              textStyle: {
                color: '#999'
              }
            },
            splitLine: {
              show: false
            }
          }],
          series: seriesData
        };
        /*
        let i = 0
        let that = this
        this.intervalId = setInterval(function(){
            // console.log(i)
            i = i === xData.length ? 0 : i+1
            that.$refs.option.dispatchAction({
                type: 'showTip',
                seriesIndex:0,  // 显示第几个series
                dataIndex: i // 显示第几个数据
            });
        }, 1000)
        */
      },
      dealSeriesData() {
        let xData = this.dataSource.dateArr
        let minArr = this.dataSource.minArr
        let maxArr = this.dataSource.maxArr
        let avgArr = this.dataSource.avgArr
        let rtdArr = this.dataSource.rtdArr

        let seriesData = []
        if(minArr.length>0) {
          let item = {
            name: this.$t('最小值'),
            type: 'line',
            data: minArr,
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
              width: 2,
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: '#9effff'
                },
                {
                  offset: 1,
                  color: '#9E87FF'
                }
              ]),
              shadowColor: 'rgba(158,135,255, 0.1)',
              shadowBlur: 10,
              shadowOffsetY: 20
            },
            itemStyle: {
              normal: {
                color: colorList[0],
                borderColor: colorList[0]
              }
            }
          }
          seriesData.push(item)
        }
        if(maxArr.length>0) {
          let item = {
              name: this.$t('最大值'),
              type: 'line',
              data: maxArr,
              symbolSize: 1,
              symbol: 'circle',
              smooth: true,
              yAxisIndex: 0,
              showSymbol: false,
              lineStyle: {
                width: 2,
                color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                    offset: 0,
                    color: '#73DD39'
                  },
                  {
                    offset: 1,
                    color: '#73DDFF'
                  }
                ]),
                shadowColor: 'rgba(115,221,255, 0.1)',
                shadowBlur: 10,
                shadowOffsetY: 20
              },
              itemStyle: {
                normal: {
                  color: colorList[1],
                  borderColor: colorList[1]
                }
              }
          }
          seriesData.push(item)
        }
        if(avgArr.length>0) {
          let item = {
            name: this.$t('平均值'),
            type: 'line',
            data: avgArr,
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
              width: 2,
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: '#fe9a'
                },
                {
                  offset: 1,
                  color: '#fe9a8b'
                }
              ]),
              shadowColor: 'rgba(254,154,139, 0.1)',
              shadowBlur: 10,
              shadowOffsetY: 20
            },
            itemStyle: {
              normal: {
                color: colorList[2],
                borderColor: colorList[2]
              }
            }
          }
          seriesData.push(item)
        }
        if(rtdArr.length>0) {
          let item = {
            name: this.$t('实时值'),
            type: 'line',
            data: rtdArr,
            symbolSize: 1,
            symbol: 'circle',
            smooth: true,
            yAxisIndex: 0,
            showSymbol: false,
            lineStyle: {
              width: 2,
              color: new echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                  offset: 0,
                  color: '#fe9a'
                },
                {
                  offset: 1,
                  color: '#fe9a8b'
                }
              ]),
              shadowColor: 'rgba(254,154,139, 0.1)',
              shadowBlur: 10,
              shadowOffsetY: 20
            },
            itemStyle: {
              normal: {
                color: colorList[2],
                borderColor: colorList[2]
              }
            }
          }
          seriesData.push(item)
        }
        return seriesData;
      }
    }
  }
</script>
